import { mapGetters, mapMutations } from "vuex";
import paymentTerms from "../../paymentTerms/paymentTerms.vue";
import BalanceApi from "@/services/api/balanceApi";
import { checkoutHelper } from "@/components/mixin/checkoutHelper";

const BalanceApiService = new BalanceApi();

export default {
  mixins: [checkoutHelper],
  components: {
    paymentTerms,
  },
  data: function () {
    return {
      addressConfig: null,
      balanceOrderSuccess: false,
      transactionData: null,
      financed : true,
      creditAvailable : true,
      creditLimit: null
    };
  },
  computed: {
    cart() {
      return this.$store.getters.checkoutState.cart;
    },
    ...mapGetters({
      userContext: "userContext",
    }),
    isBalanceUser() {
      return this.$store.getters.userContext?.balance_id !== null
        && this.$store.getters.userContext?.use_balance
    },
  },
  watch: {
    "userContext": async function() {
      await this.getBalance();
    }
  },
  async mounted() {
    this.clearPromoCodeState();
    this.address = this.$store.getters.checkoutState.shipping;
    window.balanceCheckout.init({
      hideDueDate: true,
      hideDueDateText:'shipment',
      isAuth: true,
      onSuccess: this.onSuccess,
      skipSuccessPage: true,
      onError: function (error) {
        this.$logger.notify(new Error(error));
      },
      onClose: function () {},
      onCancel: function () {},
    });
    if (this.userContext?.use_balance) {
      await this.getBalance();
    }
  },
  methods: {
    ...mapMutations(["clearPromoCodeState"]),
    async handlePaymentClick() {
      await this.saveAddresses();
      this.addressConfig = this.getAddressConfig();
      try {
        const { data } = await BalanceApiService.getTransactionToken({
          ...{ financed : this.financed },
          ...this.addressConfig
        });
        this.transactionData = data;
      } catch (error) {
        this.$logger.notify(new Error(error));
      }
      window.balanceCheckout.render(this.transactionData.token, "#balance-checkout");
    },
    buildOrderPayload() {
      const promoCodes = [];
      this.cart.sub_carts.forEach((cart) => {
        if (cart.promo_code) {
          promoCodes.push(cart.promo_code);
        }
      });
      return {
        ...this.addressConfig,
        ...{
          token_id: this.transactionData.token,
          transaction_id: this.transactionData.id,
        },
        ...(promoCodes.length && { promo_codes: promoCodes }),
      };
    },
    async onSuccess() {
      const payload = this.buildOrderPayload();
      const { data } = await BalanceApiService.createBalanceOrder(payload);
      await this.$utils.setRetailerStores(this);
      this.$router.push(`/checkout/order-confirmation/${data.id}`);
    },
    async getBalance() {
      if (this.userContext.qualification_status === "NOT_APPLIED") {
        this.financed = false;
        this.creditAvailable = false;
      } else {
        const { data } = await BalanceApiService.getBuyerCreditLimit(this.userContext.balance_id);
        this.creditAvailable = data.creditLimit > 0;
        this.creditLimit = new Intl.NumberFormat().format(data.creditLimit);
        if (this.creditAvailable) {
          this.financed = true;
        } else {
          this.financed = false;
        }
      }
    }
  },
};
